import { NgModule } from '@angular/core';
import { EntitlementsStoreModule } from './entitlements-store/entitlements-store.module';

@NgModule({
    imports: [EntitlementsStoreModule],
    exports: [EntitlementsStoreModule]
})
export class EntitlementsLibModule {}
